// Headings used to animate in word by word (250ms delay, then 80ms per word,
// each taking 650ms), triggered only once the heading scrolled into view. On a
// slow device or a fast scroll the page title was missing for seconds: the
// audit caught "/alternatives/chatgpt" showing only "Top 7" after 3s. A title
// is the first thing a reader needs, so it now renders immediately. The
// component is kept so existing call sites need no change.
export default function WordReveal({ children, className = '' }) {
  return <span className={className}>{children}</span>
}
